import React from 'react';
import styles from './page1.scss';
import pic1 from './1.png';
import pic2 from './2.png';
import pic3 from './3.png';
import pic4 from './4.png';
import pic5 from './5.png';
import pic6 from './6.png';

function Page1(props) {
  return (
    <div className={styles['page1']} ref={props.myRef}>
      <div className={styles['page1-main']}>
        <div className={styles['page1-title']}>OUT PARTNERS</div>

        <div className={styles['page1-title-subTitle']}>
          <div className={styles['page1-title-subTitle-num']}>1</div>
          <div className={styles['page1-title-subTitle-text']}>合作项目</div>
        </div>

        <div className={styles['page1-cardList']}>
          <div className={styles['page1-card']}>
            <img src={pic1} />

            <span className={styles['small']}>WOW-TREND</span>
            <span className={styles['small']}>x</span>
            <span className={styles['big']}>PREMIÈRE VISION PARIS</span>

            <div className={styles['page1-card-desc']} style={{ backgroundColor: '#2C48D7', opacity: '0.8' }}>
              <div className={styles['page1-card-desc-title']}>
                WOW-TREND<br />
                ×<br />
                PREMIÈRE VISION PARIS
              </div>

              <div className={styles['page1-card-desc-text']}>
                受法国Première Vision Paris趋势研究媒体邀约参与面料展时尚趋势版块的研究分享，成为中国市场数据采集、时尚趋势版块、媒体版块深度合作伙伴；
              </div>
            </div>
          </div>

          <div className={styles['page1-card']}>
            <img src={pic2} />

            <span className={styles['small']}>WOW-TREND</span>
            <span className={styles['small']}>x</span>
            <span className={styles['big']}>FWS</span>

            <div className={styles['page1-card-desc']} style={{ backgroundColor: '#25B067', opacity: '0.8' }}>
              <div className={styles['page1-card-desc-title']}>
                WOW-TREND<br />
                ×<br />
                FWS
              </div>

              <div className={styles['page1-card-desc-text']}>
                英国创意设计工作室FWS Design是国际知名的图案设计工作室，作为法国PV展图案板块的固定合作伙伴，客户包括Missoni、DKNY、玛丝菲尔等品牌。<br />
                2020年，WOW-TREND携手FWS Design联合研发一系列印花图案，并发布于趋势网站供会员客户参考使用。
              </div>
            </div>
          </div>

          <div className={styles['page1-card']}>
            <img src={pic3} />

            <span className={styles['small']}>WOW-TREND</span>
            <span className={styles['small']}>x</span>
            <span className={styles['big']}>唯品会</span>

            <div className={styles['page1-card-desc']} style={{ backgroundColor: '#DE2727', opacity: '0.8' }}>
              <div className={styles['page1-card-desc-title']}>
                WOW-TREND<br />
                ×<br />
                唯品会
              </div>

              <div className={styles['page1-card-desc-text']}>
                特邀CEO兼首席创意官李冰与首席色彩趋势总监马蓉成为趋势课程特约讲师。<br />
                专家顾问团队为唯品特卖会提供专业的组货建议。<br />
                为唯品会打造定制型内训课程。
              </div>
            </div>
          </div>

          <div className={styles['page1-card']}>
            <img src={pic4} />

            <span className={styles['small']}>WOW-TREND</span>
            <span className={styles['small']}>x</span>
            <span className={styles['big']}>CHANEL 工艺坊</span>

            <div className={styles['page1-card-desc']} style={{ backgroundColor: '#FFEA00', opacity: '0.8' }}>
              <div className={styles['page1-card-desc-title']}>
                WOW-TREND<br />
                ×<br />
                CHANEL 工艺坊
              </div>

              <div className={styles['page1-card-desc-text']}>
                作为海外高端资源之一的CHANEL—Lasage刺绣工坊，是WOW-TREND海外游学行程的其中一环。我们带领游学团队在创始于1858年的Lasage刺绣工坊中参观与学习，近距离感受这个凝聚了几代工匠独特技艺的百年工坊。
              </div>
            </div>
          </div>

          <div className={styles['page1-card']}>
            <img src={pic5} />

            <span className={styles['small']}>WOW-TREND</span>
            <span className={styles['small']}>x</span>
            <span className={styles['big']}>Chloé 档案馆</span>

            <div className={styles['page1-card-desc']} style={{ backgroundColor: '#6D3825', opacity: '0.8' }}>
              <div className={styles['page1-card-desc-title']}>
                WOW-TREND<br />
                ×<br />
                Chloé 档案馆
              </div>

              <div className={styles['page1-card-desc-text']}>
                CHLOE档案馆于2011年建立，我们与其合作独家开放私服体验。可带领团队从品牌历史到设计打板工作室，再到订货会现场一一观摩学习，并邀请到CHLOE创始人的孙女Mikhaela亲自解读这个打造法式浪漫的秘密基地。
              </div>
            </div>
          </div>

          <div className={styles['page1-card']}>
            <img src={pic6} />

            <span className={styles['small']}>WOW-TREND</span>
            <span className={styles['small']}>x</span>
            <span className={styles['big']}>北京服装学院</span>

            <div className={styles['page1-card-desc']} style={{ backgroundColor: '#A23080', opacity: '0.8' }}>
              <div className={styles['page1-card-desc-title']}>
                WOW-TREND<br />
                ×<br />
                北京服装学院
              </div>

              <div className={styles['page1-card-desc-text']}>
                每年学校组织师生团队到WOW-TREND总部参观交流。<br />
                定期举办趋势发布会-北服专场，为上百位学生带来最新的趋势资讯。<br />
                CEO兼首席创意官李冰作为特邀讲师、专家评审团队一员，参与学校活动。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1;